if (typeof JW === 'undefined') JW = {};
JW.Adm = (function ($)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'ADM';
    _pri.po_cnf = '<div class="popover cnf" role="tooltip"><div class="arrow cnf"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
    _pri.po_footer = '<div class="po-footer"><a id="cnf-ok" class="btn btn-primary-l rpl cup">OK</a> <a id="cnf-cancel" class="btn btn-secondary rpl cup">Abbrechen</a></div>';
    _pri.opts = {
        dbg_lvl: 1,
        dp_opts: {
            zIndexOffset:          1010,
            autoclose:             true,
            calendarWeeks:         true,
            daysOfWeekHighlighted: '[0,6]',
            format:                'dd.mm.yyyy',
            language:              'de',
            todayBtn:              'linked',
            todayHighlight:        true,
            weekStart:             1,
            templates: {
                leftArrow:  '<i class="fa fa-chevron-left"></i>',
                rightArrow: '<i class="fa fa-chevron-right"></i>'
            }
        }
    };

    _pri.page   = null;
    _pri.$nav   = null;
    _pri.Calc   = null;
    _pri.inited = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.init = function()
    {
        _pri.dbgG('*** init()', _pri.cname);

        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.page = JW.Page;
        _pri.initNav();     // nav for admins only
        _pri.initCnf();     // confirms for btn or select
        _pri.initEs();      // events, ppr etc.
        _pri.initSlotSelect();
        _pri.initEinvCalc();
    };

    _pri.initEs = function()
    {
        $(document).on('click', '.frmbtn', _pri.frmBtnClick);
        $(document).on('change', '.chsel', _pri.changedSelect);
        $(document).on('click', '.xbtn', function(e) {
            $($(this).data('tgt')).hide(250);
        });
        $('.chsub').on('change',function(e) {
            e.stopPropagation();
            e.preventDefault();

            var $this = $(this);
            $this.closest('form').submit();

            return false;
        });
        $(document).on('click', '.jsbtn', _pri.onJsBtnClick);
        // $('.jsbtn').on('click', _pri.onJsBtnClick);
        $('.ordbtn').on('click', _pri.onOrdBtnClick);
        $('.datepicker.auto').datepicker(_pri.opts.dp_opts);

        $(document).on('click', 'a.aup', function(e) {
            _pri.dbg('*** a.aup click()');
            var wrapper = $(this).closest('tr');
            wrapper.insertBefore(wrapper.prev());
        });
        $(document).on('click', 'a.adown', function(e) {
            _pri.dbg('*** a.aup click()');
            var wrapper = $(this).closest('tr');
            wrapper.insertAfter(wrapper.next());
        });

        $(document).on('click', 'a.aup2', _pri.aUpDown2);
        $(document).on('click', 'a.adown2', _pri.aUpDown2);

        _pri.page.on('adm:aupdown2_upd', function(e, o) {
            _pri.dbg('on adm:aupdown2_upd o: ', o);
            if (_pri.isObj(o) && typeof o['isel'] === 'string')
            {
                _pri.aUpDown2Upd(o['isel']);
            }
        });

        _pri.page.on('adm:on_calc_inp', function(e, o) {
            _pri.dbg('*** on adm:on_calc_inp');
            if (_pri.isObj(_pri.Calc))
            {
                _pri.Calc.upd();
            }
        });

        _pri.page.on('adm:skuf_add', _pri.skufAdd);
        _pri.page.on('adm:skuf_add_ref', _pri.skufAddRef);

        _pri.page.on('adm:slc_on_load', _pri.initSlotSelect);
    };

    _pri.aUpDown2 = function(e)
    {
        _pri.dbgG('*** aUpDown2()');

        let $this = $(this);
        let wrp   = $this.data('wrp');
        let isel  = $this.data('isel'); // itemclass

        // _pri.dbg('     wrp:', wrp);
        // _pri.dbg('    isel:', isel);

        if (typeof wrp !== 'string' || typeof isel !== 'string')
        {
            _pri.dbgR('   ! no wrp or no isel!?');
            return false;
        }

        let $wrp  = $(wrp);
        let $coll = $(isel);
        let $item = $this.closest(isel);

        if ($wrp.length == 0 || $coll.length < 2 || $item.length == 0)
        {
            _pri.dbgR('   ! wrp | coll | item length = 0!?');
            return false;
        }

        // _pri.dbgR('##########################################');

        if ($this.hasClass('aup2'))
        {
            if ($item.prev().length > 0)
            {
                _pri.dbg('    -> up');
                $item.insertBefore($item.prev());
            }
        }
        else
        {
            if ($item.next().length > 0)
            {
                _pri.dbg('    <- down');
                $item.insertAfter($item.next());
            }
        }

        // _pri.aUpDown2Upd(isel); // done by observer page mutob ...
    };

    _pri.skufAdd = function(e, ret)
    {
        _pri.dbgG('*** skufAdd() ret:', ret);
        if (_pri.isObj(ret) && typeof ret.items_wrp === 'string' && typeof ret.frame_k === 'string')
        {
            let $frames = $('.skuf_ref_frame');
            // _pri.dbg('    frames length:', $frames.length);
            if ($frames.length < 1)
            {
                _pri.dbgR('    !!! no frames?!');
                return;
            }

            let $frame = $('#skuf_ref_frame' + ret.frame_k);
            if ($frame.length != 1)
            {
                _pri.dbgR('    !!! where\'s my frame?!');
                return;
            }

            _pri.dbg('    yup, items_wrp:', ret.items_wrp);
            let $items = $(ret.items_wrp + ' .skuform_item_wrp');
            _pri.dbg('    items length:', $items.length);

            let $items_all = $('.skuf_ref_frame .skuform_item_wrp');
            _pri.dbg('    all items length:', $items_all.length);

            let has_ref = true;
            let ref_type_selected = $frame.find('input[name="ref_type' + ret.frame_k + '"]:checked');
            if (ref_type_selected.length == 0)
            {
                has_ref = false;
            }
            _pri.dbgB('    has_ref:', has_ref);


            let cll = {};
            if (_pri.isObj(ret.case_any))
            {
                $.extend(true, cll, ret.case_any);
            }

            if (_pri.isObj(ret.case_items0) && $items.length == 0 && !has_ref)
            {
                $.extend(true, cll, ret.case_items0);
            }

            let empty = false;
            let $txt_offer = $('#txt_top_offer');
            let $txt_bill  = $('#txt_top_bill');
            if ($txt_offer.length > 0 && $txt_bill.length > 0 && $txt_offer.val() == '' && $txt_bill.val() == '')
            {
                empty = true;
            }

            if (_pri.isObj(ret.case_all0) && $items_all.length == 0 && empty)
            {
                $.extend(true, cll, ret.case_all0);
            }

            let pub_type   = $('input[name="pub_type"]:checked').val();
            _pri.dbgR('    #### pub_type:checked: [' + pub_type + ']');
            if (typeof pub_type === 'undefined' && _pri.isObj(ret.case_nopubt))
            {
                $.extend(true, cll, ret.case_nopubt);
            }

            let poss_hdl = $('input[name="poss_hdl"]').val();
            if (poss_hdl == '' && _pri.isObj(ret.case_nophdl))
            {
                $.extend(true, cll, ret.case_nophdl);
            }

            _pri.dbg('    cll:', cll);
            JW.Modal.handleJSONRet(cll);

        }
    };

    _pri.skufAddRef = function(e, ret)
    {
        _pri.dbgG('*** skufAddRef() ret:', ret);
        if (_pri.isObj(ret) && _pri.isObj(ret.frames))
        {
            _pri.dbg('    so far ...');

            let cll = {};

            if (_pri.isObj(ret.case_any))
            {
                $.extend(true, cll, ret.case_any);
            }

            let pub_type   = $('input[name="pub_type"]:checked').val();
            _pri.dbgR('    #### pub_type:checked: [' + pub_type + ']');
            if (typeof pub_type === 'undefined' && _pri.isObj(ret.case_nopubt))
            {
                $.extend(true, cll, ret.case_nopubt);
            }

            let poss_hdl = $('input[name="poss_hdl"]').val();
            if (poss_hdl == '' && _pri.isObj(ret.case_nophdl))
            {
                $.extend(true, cll, ret.case_nophdl);
            }

            let $items_all = $('.skuf_ref_frame .skuform_item_wrp');
            _pri.dbg('    all items length:', $items_all.length);

            if (_pri.isObj(ret.case_all0) && $items_all.length == 0)
            {
                $.extend(true, cll, ret.case_all0);
            }

            _pri.dbg('    cll:', cll);
            JW.Modal.handleJSONRet(cll);
        }
    };

    //################################################################
    //################################################################
    //################################################################

    _pri.initEinvCalc = function()
    {
        _pri.dbgG('*** initEinvCalc()');
        let $elm = $('.einvcalc');
        // _pri.dbg('    elm?', $elm);
        if ($elm.length != 1)
        {
            return false;
        }

        const Calc       = {};
        Calc.$elm        = $elm;
        Calc.frames      = new Map();
        Calc.rx_dotfloat = /\.(?=.*\.)/g;

        Calc.assertDotFloat = function(val)
        {
            val = val.replace(',', '.');

            val = val.replace(Calc.rx_dotfloat, '');

            return parseFloat(val);
        };

        Calc.rnd = function(val) {
            return (Math.round((val + Number.EPSILON) * 1000) / 1000);
        };

        Calc.initFrame = function($frame, id)
        {
            _pri.dbgY('    *** initFrame()');
            const Frame = {};

            Frame.initItem = function($item, id)
            {
                _pri.dbgY('    *** initItem()');
                const Item = {};

                Item.inps = new Map();

                Item.getQuantity = () => {
                    return parseInt(Item.inps.get('quantity').val());
                };
                Item.getPrice = () => {
                    return Calc.assertDotFloat(Item.inps.get('price').val());
                };
                Item.getTaxPerc = () => {
                    return Calc.assertDotFloat(Item.inps.get('tax_perc').val());
                };
                Item.getDiscPerc = () => {
                    return Calc.assertDotFloat(Item.inps.get('disc_perc').val());
                };

                Item.getPosPrice = () => {
                    return Item.getPrice() * Item.getQuantity();
                };
                Item.getPosDiscAmount = () => {
                    let disc_amount = 0;
                    if (Item.getQuantity() != 0)
                    {
                        disc_amount = (Item.getPosPrice() * Item.getDiscPerc()) / 100;
                    }
                    return disc_amount;
                };
                Item.getPosNetAmount = () => {
                    return Item.getPosPrice() - Item.getPosDiscAmount();
                };
                Item.getPosTaxAmount = () => {
                    return (Item.getTaxPerc() / 100) * Item.getPosNetAmount();
                };
                Item.getBrutAmount = () => {
                    return Item.getPosNetAmount() + Item.getPosTaxAmount();
                };


                Item.addSum = function()
                {
                    let sum = {};
                    sum.pos_price = Calc.rnd(Item.getPosPrice());
                    sum.disc      = Calc.rnd(Item.getPosDiscAmount());
                    sum.tax       = Calc.rnd(Item.getPosTaxAmount());
                    sum.net       = Calc.rnd(Item.getPosNetAmount());
                    sum.brut      = Calc.rnd(Item.getBrutAmount());

                    // _pri.dbgY('    Item sum:', sum);
                    // _pri.dbg('        rnd:', 3845.4849999999997, Calc.rnd(3845.4849999999997));

                    Frame.sum.pos_price += sum.pos_price;
                    Frame.sum.disc      += sum.disc;
                    Frame.sum.tax       += sum.tax;
                    Frame.sum.net       += sum.net;
                    Frame.sum.brut      += sum.brut;
                };

                // skuitem_7337d2fb7daa0c3b3491a046cbd73e62_disc_perc
                let rx = RegExp('^skuitem_[0-9a-f]{32}_([a-z_]+)$');

                Item.initInps = function()
                {
                    let $inps = Item.$elm.find('input.calcinp');
                    $.each($inps, function(k, v) {
                        let $inp = $(v);
                        let name = $inp.attr('name');
                        // _pri.dbg('    name: ', name);
                        let mtc = rx.exec(name);
                        // _pri.dbg(mtc);
                        if (mtc && mtc.length == 2)
                        {
                            $inp.on('input', function() {
                                _pri.dbg('    calc inp on input');
                                _pri.page.trigger('adm:on_calc_inp');
                            });
                            Item.inps.set(mtc[1], $inp);
                        }
                        else
                        {
                            _pri.dbgR('    !!! unknown input! name:', name);
                        }
                    });
                };

                Item.clear = function()
                {
                    _pri.dbgG('*** Item.clear()');
                    Item.inps.forEach(function($inp, k, map) {
                        $inp.off('input');
                    });
                };

                Item.id   = id;
                Item.$elm = $item;
                Frame.items.set(id, Item);

                Item.initInps();
            };

            Frame.getSum = function()
            {
                Frame.sum =
                {
                    pos_price: 0,
                    disc     : 0,
                    tax      : 0,
                    net      : 0,
                    brut     : 0
                };

                Frame.items.forEach(function(item, k, map) {
                    item.addSum();
                });

                // _pri.dbgB('    Frame sum:', Frame.sum);
                // _pri.dbgB('    Calc sum:', Calc.sum);

                $.each(Frame.sum_inps, function(k, v) {

                    // _pri.dbgB('        ' + k);
                    if (_pri.isObj(v))
                    {
                        // _pri.dbgG('    set val:', Frame.sum[k], v);
                        v.val(_pri.numberFormat(Frame.sum[k], 2, ',', '.') + ' €');
                        v.trigger('change');
                    }
                    else
                    {
                        _pri.dbgR('    !!! frame inp not found! k:', k);
                    }
                });

                Calc.sum.pos_price = Calc.rnd(Calc.sum.pos_price)   + Calc.rnd(Frame.sum.pos_price);
                Calc.sum.disc      = Calc.rnd(Calc.sum.disc)        + Calc.rnd(Frame.sum.disc);
                Calc.sum.tax       = Calc.rnd(Calc.sum.tax)         + Calc.rnd(Frame.sum.tax);
                Calc.sum.net       = Calc.rnd(Calc.sum.net)         + Calc.rnd(Frame.sum.net);
                Calc.sum.brut      = Calc.rnd(Calc.sum.brut)        + Calc.rnd(Frame.sum.brut);

                // _pri.dbgG('    Calc sum:', Calc.sum);
            };

            Frame.findItems = function()
            {
                let ids = new Map();
                let $items = Frame.$elm.find('.skuform_item_wrp');
                $.each($items, function(k, v) {
                    let $i = $(v);
                    let id = $i.attr('id');
                    ids.set(id, 1);
                    if (Frame.items.has(id))
                    {
                        // _pri.dbgY('    !!! items has id!');
                        return;
                    }
                    else
                    {
                        Frame.initItem($i, id);
                    }
                });

                let dele = new Map();
                Frame.items.forEach(function(item, k, map) {
                    // _pri.dbg('    check in ids for items k:', k);
                    if (!ids.has(k))
                    {
                        dele.set(k, 1);
                    }
                });

                dele.forEach(function(val, k, map) {
                    _pri.dbgR('    finally delete item k:', k);
                    let item = Frame.items.get(k);
                    item.clear();
                    Frame.items.delete(k);
                });
            };

            Frame.initSumInps = () => {
                Frame.sum_inps =
                {
                    pos_price: null,
                    disc     : null,
                    tax      : null,
                    net      : null,
                    brut     : null
                };

                $.each(Frame.sum_inps, function(k, v) {
                    // _pri.dbg('        ' + k);

                    let $inp = Frame.$elm.find('input[name="' + k + '"]');
                    if ($inp.length == 1)
                    {
                        Frame.sum_inps[k] = $inp;
                    }
                    else
                    {
                        _pri.dbgR('    !!! frame inp not found! k:', k);
                    }
                });
            };

            Frame.id    = id;
            Frame.$elm  = $frame;
            Frame.items = new Map();
            Calc.frames.set(id, Frame);

            Frame.initSumInps();
            Frame.findItems();
        };

        Calc.updFrame = ($frame, id) => {

            $frame.findItems();
        };

        Calc.getSum = function()
        {
            _pri.dbgG('*** Calc.getSum()');

            Calc.sum =
            {
                pos_price: 0,
                disc     : 0,
                tax      : 0,
                net      : 0,
                brut     : 0
            };

            Calc.frames.forEach(function(frame, k, map) {
                // _pri.dbg('        1 Calc sum:', Calc.sum);
                frame.getSum();
                // _pri.dbg('        2 Calc sum:', Calc.sum);
            });

            // _pri.dbgG('    11 Calc sum:', Calc.sum);

            $.each(Calc.sum, function(k, v) {
                Calc.sum[k] = Calc.rnd(v);
            });

            // _pri.dbgG('    22 Calc sum:', Calc.sum);

            $.each(Calc.sum_inps, function(k, v) {

                // _pri.dbgB('        ' + k);
                if (_pri.isObj(v))
                {
                    // _pri.dbgG('    set val:', Calc.sum[k], v);
                    v.val(_pri.numberFormat(Calc.sum[k], 2, ',', '.') + ' €');
                    v.trigger('change');
                }
                else
                {
                    _pri.dbgR('    !!! calc inp not found! k:', k);
                }
            });

            // _pri.dbgR('    Calc.sum:', Calc.sum);
        };

        Calc.findFrames = function()
        {
            _pri.dbgG('*** Calc.findFrames()');

            let ids = new Map();
            let $frames = Calc.$elm.find('.skuf_ref_frame');
            $.each($frames, function(k, v) {
                let $f = $(v);
                let id = $f.attr('id');
                ids.set(id, 1);
                if (Calc.frames.has(id))
                {
                    // _pri.dbgY('    !!! frames has id!');
                    Calc.updFrame(Calc.frames.get(id), id);
                }
                else
                {
                    Calc.initFrame($f, id);
                }
            });

            let dele = new Map();
            Calc.frames.forEach(function(frame, k, map) {
                // _pri.dbg('    check in ids for frames k:', k);
                if (!ids.has(k))
                {
                    dele.set(k, 1);
                }
            });

            dele.forEach(function(val, k, map) {
                _pri.dbgR('    finally delete frame k:', k);
                let frame = Calc.frames.get(k);
                frame.items.forEach(function(item, k, map) {
                    item.clear();
                });
                Calc.frames.delete(k);
            });
        };

        Calc.upd = function()
        {
            _pri.dbgG('*** Calc.upd()');
            // _pri.dbg('    call Cal.findFrames() ...');
            Calc.findFrames();
            // _pri.dbg('    call Cal.getSum() ...');
            Calc.getSum();
        };

        Calc.init = () => {

            Calc.sum_inps =
            {
                pos_price: null,
                disc     : null,
                tax      : null,
                net      : null,
                brut     : null
            };

            $.each(Calc.sum_inps, function(k, v) {
                // _pri.dbg('        ' + k);

                let $inp = $('#calc_sum_inps').find('input[name="' + k + '"]');
                if ($inp.length == 1)
                {
                    Calc.sum_inps[k] = $inp;
                }
                else
                {
                    _pri.dbgR('    !!! calc inp not found! k:', k);
                }
            });

            Calc.upd();
        };

        Calc.init();
        _pri.Calc = Calc;
    };

    //################################################################
    //################################################################
    //################################################################

    _pri.aUpDown2Upd = function(isel)
    {
        _pri.dbgG('*** aUpDown2Upd() isel:', isel);

        $coll = $(isel);

        let len = $coll.length;

        if (len > 0)
        {
            _pri.dbg('    coll len:', len);

            $.each($coll, function(k, v) {

                let $it = $(v);
                let $updown2 = $it.find('.aupdown2');

                if ($updown2.length > 0)
                {
                    $updown2.removeClass('aupdown2f aupdown2l');

                    if (k == 0)
                    {
                        $updown2.addClass('aupdown2f');
                    }

                    if (k == len - 1)
                    {
                        $updown2.addClass('aupdown2l');
                    }
                }
            });
        }
    };

    _pri.initCnf = function()
    {
        var cnf;
        _pri.clearCnf = function()
        {
            cnf = {
                    open:     false,
                    $frm:     null,
                    sbm:      '',       // submit type: '', 'ev'
                    cll:      null,
                    $trigger: null,
                    fks: {}
                };
        };

        _pri.cnfClose = function()
        {
            _pri.dbg('*** cnfClose() typeof po.popover: ', typeof cnf.$trigger.popover === 'function');
            if (cnf.open && cnf.$trigger != null && typeof cnf.$trigger.popover === 'function')
            {
                _pri.dbg('    calling popover.dispose() ...');
                cnf.$trigger.popover('dispose');
            }
            _pri.clearCnf();
        }

        _pri.cnfCancel = function(e)
        {
            if (typeof e === 'object')
            {
                e.stopPropagation();
                e.preventDefault();
            }
            _pri.dbg('*** cnfCancel() typeof cnf.$trigger:', typeof cnf.$trigger);
            if (cnf.$trigger != null)
            {
                if (cnf.$trigger.prop('tagName') == 'SELECT')
                {
                    cnf.$trigger.val('');
                }
            }
            _pri.cnfClose();
            return false;
        };

        _pri.cnfOk = function(e)
        {
            _pri.dbg('*** cnfOk()');
            e.stopPropagation();
            e.preventDefault();
            if (cnf.$frm && cnf.$frm.length > 0)
            {
                _pri.dbg('    frm mode ...');
                // cnf.$frm.find('input[name="act"]').val(cnf.act);
                // cnf.$frm.find('input[name="act_id"]').val(cnf.act_id);
                for (var fk in cnf.fks)
                {
                    if (cnf.fks.hasOwnProperty(fk))
                    {
                        cnf.$frm.find('input[name="' + fk + '"]').val(cnf.fks[fk]);
                    }
                }

                if (cnf.sbm == 'ev')
                {
                    cnf.$frm.trigger('ev_form_submit');
                }
                else
                {
                    cnf.$frm.submit();
                }
            }
            else if (typeof cnf.cll === 'object' && cnf.cll != null)
            {
                _pri.dbg('    cll mode ...');

                var cll = cnf.cll;
                _pri.cnfClose();
                JW.Modal.cll(cll);
                return false;
            }

            _pri.cnfClose();
            return false;
        };

        _pri.cnfTrigger = function(e)
        {
            _pri.dbg('*** cnfTrigger()');
            e.stopPropagation();
            e.preventDefault();
            if (cnf.open)
            {
                _pri.cnfCancel();
            }

            _pri.dbg('1');
            var $this = $(this);
            var msg = '';

            cnf.$trigger = $this;

            var $elm;
            if ($this.prop('tagName') == 'SELECT')
            {
                $elm = $this.find('option:selected');
            }
            else
            {
                $elm = $this;
            }

            _pri.dbg('1.1');
            if ($elm.length < 1)
            {
                _pri.clearCnf();
                return;
            }

            _pri.dbg('2');
            var $frm = $($this.data('frm'));
            var cll  = $elm.data('cll');
            if ($frm.length > 0)
            {
                _pri.dbg('2.1');
                cnf.$frm = $frm;
                cnf.cll  = null;
                let sbm = $this.data('sbm');
                if (typeof sbm === 'string')
                {
                    _pri.dbg('    sbm:', sbm);
                    cnf.sbm = sbm;
                }
            }
            else if (typeof cll === 'object' && cll != null)
            {
                _pri.dbg('2.2 cll:', cll);
                cll._$elm = $elm;
                cnf.cll   = cll;
                cnf.$frm  = null;
            }
            else
            {
                _pri.dbg('2.3');
                _pri.clearCnf();
                return;
            }

            _pri.dbg('3');
            // form keys
            var fks = $elm.data('fks');
            if (typeof fks !== 'undefined')
            {
                cnf.fks = {};
                var fka = fks.split(',');
                $.each(fka, function(k, v) {
                    if (typeof v === 'string' && v != '')
                    {
                        // post key value
                        var fkv = $elm.data(v);
                        if (typeof fkv !== 'undefined')
                        {
                            cnf.fks[v] = fkv;
                        }
                        else
                        {
                            cnf.fks[v] = '';
                        }
                    }
                });
            }
            msg = $elm.data('msg');
            if (typeof msg === undefined)
            {
                msg = '';
            }
            plc = $elm.data('plc');
            if (typeof plc !== 'string' || plc == '')
            {
                plc = 'auto';
            }
            _pri.dbg('4');
            if (typeof msg === 'string' && msg != '')
            {
                _pri.dbg('5');
                $this.popover({
                    html: true,
                    template: _pri.po_cnf,
                    title: 'Bestätigung',
                    content: (msg + _pri.po_footer),
                    // trigger: 'focus',
                    delay: { 'show': 0, 'hide': 250 },
                    // container: $this.parent().parent().parent().parent(),
                    placement: plc
                }).popover('show');
            }
            else if (cnf.$frm != null)
            {
                // without popover confirmation?! ??? 200927 ... ???
                _pri.dbgR('6 - without popover confirmation?!');
                for (var fk in cnf.fks)
                {
                    if (cnf.fks.hasOwnProperty(fk))
                    {
                        cnf.$frm.find('input[name="' + fk + '"]').val(cnf.fks[fk]);
                    }
                }
                _pri.clearCnf();
            }
        };

        // $(document).on('hidden.bs.popover', function (e) {
        //     _pri.dbg('*** on hidden.bs.popover ...');
        //     // _pri.cnfClose();
        // });
        $(document).on('shown.bs.popover', function (e) {
            _pri.dbg('*** on shown.bs.popover ...');
            _pri.dbg('    e.target:', e.target);

            $tgt = $(e.target);
            if ($tgt.hasClass('frmcnf') || $tgt.hasClass('cllcnf') || $tgt.hasClass('chcnf'))
            {
                _pri.dbg('    ... is cnf ...');
                // _pri.cnfClose();
                cnf.open = true;
            }
        });

        $(document).on('click','#cnf-cancel', _pri.cnfCancel);
        $(document).on('click','#cnf-ok', _pri.cnfOk);

        $(document).on('click', function(e) {
            if (cnf.open && cnf.$trigger != null && typeof cnf.$trigger.popover === 'function')
            {
                var $el = $(cnf.$trigger.data('bs.popover').tip);
                _pri.dbg($el);
                if (!$el.is(e.target) && $el.has(e.target).length === 0)
                {
                    _pri.cnfCancel();
                }
            }
        });

        $(document).on('click', '.frmcnf', _pri.cnfTrigger);
        $(document).on('click', '.cllcnf', _pri.cnfTrigger);
        $(document).on('change', '.chcnf', _pri.cnfTrigger);

        _pri.clearCnf();
    };

    _pri.frmBtnClick = function(e)
    {
        _pri.dbg('*** frmBtnClick()');
        e.stopPropagation();
        e.preventDefault();
        var $this = $(this);
        var act = $this.data('act');

        if (typeof act === 'undefined' || act == 'sub')
        {
            var $frm = $($this.data('frm'));
            var $inp = $($this.data('inp'));
            var val  = $this.data('val');
            $inp.val(val);
            $frm.submit();
        }
        return false;
    };

    _pri.initNav = function()
    {
        // _pri.$ambtn = $('#ambtn');

        $(document).on('mouseenter click', '#ambtn', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            _pri.dbg('ambtn mouseenter');
            $('#nav-adm').removeClass('out').addClass('in').blur();
            // $(':focus').blur();
            // $('body').trigger('click');
        });

        $(document).on('mouseleave', '#nav-adm', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            _pri.dbg('nav-adm mouseleave');
            $('#nav-adm').removeClass('in').addClass('out').blur();
            // $(':focus').blur();
            // $('body').trigger('click');
        });

        $(document).on('swipeleft', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            _pri.dbg('nav-adm swipeleft');
            // _pri.dbgB('1 foc:', $(':focus'));
            $('#nav-adm').removeClass('in').addClass('out').blur();
            // $('body').trigger('click');
            // $(':focus').blur();
        });

        // $(document).on('focus', '#ambtn', function(e) {
        //     _pri.dbg('ambtn focus');
        //     $('#nav-adm').blur();
        // });

        // $('#nav-adm').on('focusout', function () {
        //     _pri.dbg('nav-adm focusout');
        //     // $(this).removeClass('in').addClass('out');
        //     $('#nav-adm').removeClass('in').addClass('out');
        // });

        // _pri.$ambtn.on('mouseenter', function() {
        //     _pri.dbg('ambtn mouseenter');
        //     $('#nav-adm').removeClass('out').addClass('in');
        // });
        //
        // $('#nav-adm').on('mouseleave', function() {
        //     _pri.dbg('nav-adm mouseleave');
        //     $('#nav-adm').removeClass('in').addClass('out');
        // });

        // _pri.$nav = $('#nav-adm');
        // _pri.$mnu = _pri.$nav.find('.mnu');
        // if (_pri.$nav.length < 1)
        // {
        //     _pri.$nav = null;
        //     return;
        // }
        //
        // _pri.$btn_nav = _pri.$nav.find('.mnu > .btn');
        // _pri.$lnks = _pri.$nav.find('.lnks');
        //
        // _pri.$mnu.on('mouseenter', function(e) {
        //     _pri.$lnks.removeClass('animated ' + 'slideOutUp adur025').show().animateCss('slideInDown adur025', function() {
        //         _pri.$lnks.css('visibility', 'visible');
        //     });
        // });
        //
        // _pri.$mnu.on('mouseleave', function(e) {
        //     _pri.$lnks.removeClass('animated ' + 'slideInDown adur025').animateCss('slideOutUp adur025', function() {
        //         _pri.$lnks.css('visibility', 'hidden');
        //     });
        // });

        $('.nav-adm-left').on('click', _pri.onNavAdmLeftClick);
    };

    _pri.onNavAdmLeftClick = function()
    {
        // _pri.dbgG('*** onNavAdmLeftClick()');

        const $this = $(this);

        let tgt  = $this.data('tgt');
        let gk   = $this.data('gk');
        let show;

        const $tgt = $(tgt);

        if ($tgt.hasClass('d-none'))
        {
            $tgt.removeClass('d-none');
            $this.find('.sign').html('-');
            show = 1;
        }
        else
        {
            $tgt.addClass('d-none');
            $this.find('.sign').html('+');
            show = 0;
        }

        $.ajax({
            type: "POST",
            url: '/_adm_nav_left',
            data: {
                gk: gk,
                show: show
            },
            dataType: 'json'
        }).done(function(ret, stat_str, jq_xhr) {
            // _pri.dbgG('*** ajx call _adm_nav_left done ...');
            // _pri.dbg('    ret: ', ret, ' | stat_str: ', stat_str, ' | jq_xhr: ', jq_xhr);
        });
    };

    _pri.addTpl = function($elm)
    {
        _pri.dbg('*** addTpl()');

        var k = md5(JW.Page.getUId().toString());

        var html = $($elm.data('item_tpl')).clone().prop('outerHTML').replace(/\{k\}/g, '_' + k);
        $tpl = $(html);
        $tpl.removeClass('d-none');
        $tpl.attr('id', k + '_wrp');
        $tgt = $($elm.data('item_tgt'));
        $tgt.append($tpl);

        var $fbtn = $tpl.find('.jw-file-btn-defer');
        $fbtn.removeClass('jw-file-btn-defer');
        $fbtn.addClass('jw-file-btn');

        $fbtn.each(function(k, v) {
            var $this = $(this);
            JW.Page.initFileBtn($this);
        });
    };

    _pri.remTpl = function($elm)
    {
        _pri.dbg('*** remTpl()');

        let rem_id = $elm.data('rem_id');
        _pri.dbg('    ', rem_id);
        if (typeof rem_id === 'string')
        {
            let $elm = $('#' + rem_id.substring(1)); // old js injects a leading _
            if ($elm.length > 0)
            {
                $elm.remove();
            }
        }
    };

    _pri.selkvSub = function($elm)
    {
        var $frm = $($elm.data('frm'));
        var $sels = $frm.find('.jb-select select');
        var $v2;

        $sels.each(function(k, v) {
            _pri.dbg('    select: ', v);
            $(v).find('option:selected').each(function(k2, v2) {
                _pri.dbg('        v2', v2);
                $v2 = $(v2);
                $v2.val(encodeURIComponent($v2.text()));
            });
        });
    };

    _pri.onJsBtnClick = function(e)
    {
        _pri.dbgG('*** onJsBtnClick()');
        var $this = $(this);
        var href = $this.data('href');
        if (typeof href === 'string' && '' != href)
        {
            window.location.href = href;
        }
        else
        {
            _pri.dbg('    form action ...');
            // var frm = $this.data('frm');    // form selector
            // var inp = $this.data('inp');    // input name
            // var val = $this.data('val');    // input val
            // var clk = $this.data('clk');    // click target selector
            // var cev = $this.data('cev');    // custom event to trigger form
            var frm, inp, val, clk, cev, mtc;
            var inps   = {};
            var rx_inp = RegExp('^inp_(.+)$');
            var rx_sub = RegExp('^(.+)Sub$');
            var incf   = '';
            var incwrp = '';
            var excf   = '';
            var mth    = '';

            $.each($this.data(), function(k, v) {
                _pri.dbg('    data.' + k + ': ' + v);
                if (k == 'frm')
                {
                    frm = v;
                }
                else if (k == 'inp')
                {
                    inp = v;
                }
                else if (k == 'val')
                {
                    val = v;
                }
                else if (k == 'clk')
                {
                    clk = v;
                }
                else if (k == 'cev')
                {
                    cev = v;
                }
                else if (k == 'incf')
                {
                    incf = v;
                }
                else if (k == 'incwrp')
                {
                    incwrp = v;
                }
                else if (k == 'excf')
                {
                    excf = v;
                }
                else if (k == 'mth')
                {
                    mth = v;
                }
                else
                {
                    mtc = k.match(rx_inp);
                    // _pri.dbg('########', mtc);
                    if (typeof mtc === 'object' && mtc != null && mtc.length > 1)
                    {
                        inps[mtc[1]] = v;
                    }
                }
            });

            if (mth != '')
            {
                _pri.dbg('typeof _pri[mth]: ', typeof _pri[mth], 'mth: ', mth, typeof _pri['addTpl']);
                if (typeof _pri[mth] === 'function')
                {
                    _pri.dbg('*** YUP is method ...');
                    _pri[mth]($this);
                    mtc = mth.match(rx_sub);
                    if (typeof mtc === 'object' && mtc != null && mtc.length > 1)
                    {

                    }
                    else
                    {
                        _pri.dbg('... nope - call method only ...');
                        return false;
                    }
                }
                else
                {
                    _pri.dbg('!!! NOPE unknown method ...');
                    return false;
                }
            }

            _pri.dbg('inps: ', inps);
            _pri.dbg('    typeof: ', typeof frm, typeof inp, typeof val);

            var $elm;
            if (typeof frm === 'string' && typeof inp === 'string' && typeof val !== 'undefined' && '' != frm && '' != inp)
            {
                if (incwrp != '')
                {
                    var els = $(incwrp).find('input:not(.lfto), select:not(.lfto), checkbox:not(.lfto), textarea:not(.lfto)');
                    if (els.length > 0)
                    {
                        var incf_arr = [];
                        if (incf != '')
                        {
                            incf_arr = incf.split(',');
                        }

                        els.each(function(i, el) {
                            _pri.dbg('    i: ', i, 'el: ', $(el).attr('name'));
                            incf_arr.push($(el).attr('name'));
                        });

                        _pri.setDataAttr($(frm), 'incf', incf_arr.join(','));
                    }
                }
                else if (incf != '')
                {
                    _pri.setDataAttr($(frm), 'incf', incf);
                }
                else if (excf != '')
                {
                    _pri.setDataAttr($(frm), 'excf', excf);
                }

                for (var p in inps)
                {
                    // _pri.dbg('    p:', p);
                    $elm = $(frm).find('input[name="' + p + '"]');
                    if ($elm.length == 0)
                    {
                        $elm = $(frm).find('select[name="' + p + '"]')
                    }

                    if ($elm.length > 0)
                    {
                        _pri.dbg('    setting: input name: ', p, ' to: ', inps[p]);
                        $elm.val(inps[p]);
                    }
                    else
                    {
                        _pri.dbg('    ... [1] element not found ...');
                    }
                }

                // _pri.dbg('   form and inp ok', frm, ' inp: ', inp);
                $elm = $(frm).find('input[name="' + inp + '"]');
                if ($elm.length == 0)
                {
                    $elm = $(frm).find('select[name="' + inp + '"]')
                }

                if ($elm.length > 0)
                {
                    $elm.val(val);
                    if (typeof clk === 'string' && '' != clk)
                    {
                        $(clk).trigger('click');
                    }
                    else if (typeof cev === 'string' && cev != '')
                    {
                        _pri.dbg('    custom event to trigger form ...');
                        $(frm).trigger(cev);
                    }
                    else
                    {
                        _pri.dbg('    submit ...');
                        $(frm).submit();
                    }
                }
                else
                {
                    _pri.dbg('    ... [2] element not found ...');
                }
            }
        }
    };

    _pri.onOrdBtnClick = function()
    {
        _pri.dbg('*** on ordbtn click');
        var $fltfrm = $('#fltfrm');
        if ($fltfrm.length > 0)
        {
            $fltfrm.find('input[name="ordk"]').val($(this).data('ordk'));
            $fltfrm.submit();
        }
    };

    _pri.changedSelect = function(e)
    {
        _pri.dbg('*** changedSelect()');
        var $this = $(this);
        var $opt  = $this.find('option:selected');
        switch ($this.attr('id'))
        {
            case 'inv_state_new':
                // _pri.dbg('    inv_state_new ...', $opt);
                var val = $opt.data('val');
                if (typeof val !== 'undefined')
                {
                    $('#paid_amount').val(val);
                    $('#paid_amount_row').removeClass('d-none');
                }
                else
                {
                    $('#paid_amount').val('');
                    $('#paid_amount_row').addClass('d-none');
                }
            break;
            default:

            break;
        }
    };

    _pri.initSlotSelect = function()
    {
        _pri.dbgG('*** initSlotSelect()');

        const sls = {};
        sls.inited = false;

        sls.run = function()
        {
            _pri.dbgG('*** sls.run()');

            sls.$wrp = $('#wrp_slot_select');

            if (sls.$wrp.length != 1)
            {
                _pri.dbg('    no wrp - return');
                return;
            }

            if (sls.inited)
            {
                _pri.dbgR('    already inited - return');
                return;
            }

            sls.inited = true;

            sls.ix = -1;
            sls.$inp_dis_slots = sls.$wrp.find('#dbd_hms');
            sls.$tds           = sls.$wrp.find('td.slot_select_td');
            sls.$trs           = sls.$wrp.find('td.slot_select_tr');

            sls.tds_map = {};
            sls.tds_len = sls.$tds.length;
            let $td, slot, i;
            for (i = 0; i < sls.tds_len; ++i)
            {
                $td = $(sls.$tds[i]);
                slot = $td.data('slot');
                sls.tds_map[slot.ix] = $td;
            }
            // _pri.dbg(sls.tds_map);

            sls.initEs();
        };

        sls.initEs = function()
        {
            sls.$wrp.find('[data-toggle="tooltip"]').tooltip({
                html: true,
                // container: 'body',
                // trigger: 'click',
                trigger : 'hover',
                template: '<div class="tooltip nosel zix-mx" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-3 text-left"></div></div>',
                boundary: 'viewport'
            });

            sls.$tds.on('click', sls.tdClick);
            sls.$trs.on('click', sls.trClick);

            sls.$wrp.on('selectstart', sls.disFunc);
        };

        sls.updInp = function()
        {
            let i, map_slot, vals = [];
            for (i = 0; i < sls.tds_len; ++i)
            {
                map_slot = sls.tds_map[i].data('slot');
                if (map_slot.sel)
                {
                    vals.push(map_slot.hm);
                }
            }
            sls.$inp_dis_slots.val(vals.join(','));
        };

        sls.test = function()
        {
            let i;
            for (i = 0; i < sls.tds_len; ++i)
            {
                _pri.dbg('td.slot_select_td:', i);
            }
        };

        sls.setSel = function($td, sel)
        {
            let slot = $td.data('slot');

            slot.sel = sel;
            $td.data('slot', slot);

            if (slot.sel)
            {
                $td.addClass('sel');
            }
            else
            {
                $td.removeClass('sel');
            }
        };

        sls.setRangeSel = function(ix0, ix1)
        {
            let min = Math.min(ix0, ix1);
            let max = Math.max(ix0, ix1);
            let i, map_slot;
            let sel = false;
            for (i = min; i <= max; ++i)
            {
                map_slot = sls.tds_map[i].data('slot');
                if (!map_slot.sel)
                {
                    sel = true;
                    break;
                }
            }

            for (i = min; i <= max; ++i)
            {
                sls.setSel(sls.tds_map[i], sel);
            }
        };

        sls.disFunc = function(e)
        {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            _pri.dbgG('*** disFunc()');
        };

        sls.tdClick = function(e)
        {
            _pri.dbgG('*** tdClick()');

            // e.preventDefault();
            // e.stopPropagation();
            // e.stopImmediatePropagation();

            let $this = $(this);
            let slot = $this.data('slot');
            _pri.dbg('slot:', slot);

            if (e.shiftKey || e.ctrlKey)
            {
                if (sls.ix > -1 && slot.ix != sls.ix)
                {
                    _pri.dbg('    SHIFT/CTRL range click');

                    sls.setRangeSel(sls.ix, slot.ix);
                    sls.ix = -1;
                }
                else
                {
                    sls.ix = slot.ix;
                }
            }
            else
            {
                sls.setSel($this, !slot.sel);
                sls.ix = -1;
            }

            sls.updInp();
        };

        sls.trClick = function(e)
        {
            let $this = $(this);
            let slots = $this.data('slots');

            _pri.dbgG('*** trClick() slots:', slots);

            sls.setRangeSel(slots.ixs[0], slots.ixs[slots.ixs.length - 1]);
            sls.ix = -1;

            sls.updInp();
        };

        sls.run();
    };

    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);
